import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { sleep } from '../../../lib/sleep';
import { PICFLOW_CONFIG } from '../../../picflow-config';
import { BoxService } from '../../../services/box.service';
import { OnGetData } from '../../../services/dialog.service';
import { StorageService } from '../../../services/storage.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-box-auth-dialog',
  imports: [LoadingIndicatorComponent, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './box-auth-dialog.component.html',
  styleUrl: './box-auth-dialog.component.scss',
})
export class BoxAuthDialogComponent implements OnGetData, OnDestroy {
  dialogName = 'box-auth';
  private config = inject(PICFLOW_CONFIG);
  private storage = inject(StorageService);
  private boxService = inject(BoxService);
  close: (accessToken?: string) => void = () => {};
  closed = false;
  url: string;
  boxAuthWindow: Window;

  dialogOptions(): DialogOptions {
    return {};
  }

  async onGetData(data: unknown, close: (refreshToken?: string) => void) {
    this.close = close;
    const redirectUrl = `${this.config.correctPicflowUrl}/a/box-auth-callback`;
    this.url = `https://account.box.com/api/oauth2/authorize?client_id=${this.boxService.clientId}&response_type=code&redirect_uri=${redirectUrl}`;
    this.openBoxAuthWindow();
    this.pollForAccessToken();
  }

  getNewWindowPosition(width: number, height: number): string {
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    return `top=${top},left=${left},height=${height},width=${width}`;
  }

  public openBoxAuthWindow() {
    this.boxAuthWindow = window.open(this.url, 'picflow-box-auth', this.getNewWindowPosition(400, 600));
    if (window.focus) this.boxAuthWindow.focus();
  }

  private async pollForAccessToken() {
    if (this.closed) return;
    const data = this.storage.get<{ refreshToken: string }>('box-refresh-token');
    if (data) return this.close(data.refreshToken);
    await sleep(100);
    this.pollForAccessToken();
  }

  ngOnDestroy(): void {
    this.closed = true;
    this.boxAuthWindow?.close();
  }
}
